import type { AuthViewKind } from '../types/auth';

/**
 * Which travel ball workspace a view kind belongs to. Coach views (a program's coaches and admins)
 * and family views (a player or a parent/guardian) never share pages: the API refuses every coach
 * `/api/travel-ball/*` route to a family view (403 `travel_ball_family_view`), and family pages read
 * nothing a coach view can.
 *
 * Branch on these, never on the view id's prefix.
 */
export const isTravelBallCoachKind = (kind: AuthViewKind | string | undefined): boolean =>
  kind === 'travelball_org';

export const isTravelBallFamilyKind = (
  kind: AuthViewKind | string | undefined,
): kind is 'travelball_player' | 'travelball_guardian' =>
  kind === 'travelball_player' || kind === 'travelball_guardian';

/** Home of a family view, for every family role. */
export const TRAVEL_BALL_FAMILY_HOME = '/travel-ball/family';
